/** Origens permitidas para embed (espelha frame-ancestors do middleware). */
export const PROGRAMA_INDICACAO_EMBED_PARENT_ORIGINS = [
	"https://www.autodromo.app",
	"https://www.vitoriamotorsjeep.com.br",
	"https://vitoriamotorsjeep.com.br",
	"https://www.vitoriamotorsmb.com.br",
	"https://vitoriamotorsmb.com.br",
	"https://www.vitoriamotorsram.com.br",
	"https://vitoriamotorsram.com.br",
] as const;

export const PROGRAMA_INDICACAO_IFRAME_MESSAGE = {
	RESIZE: "programa-indicacao:resize",
} as const;

export type ProgramaIndicacaoEmbedSource =
	| "jeep"
	| "mercedes"
	| "ram"
	| "move-brasil-jeep"
	| "jeep-avenger";

export type ProgramaIndicacaoResizeMessage = {
	type: typeof PROGRAMA_INDICACAO_IFRAME_MESSAGE.RESIZE;
	height: number;
	source: ProgramaIndicacaoEmbedSource;
};
